import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    component: () => import('../views/Home/index.vue'),
    children: [
      {
        path: 'publish-news', // 子路由 path 不需要写完整路径
        component: () => import('../views/PublishNews/index.vue')
      },
      {
        path: 'check-news', // 子路由 path 不需要写完整路径
        component: () => import('../views/CheckNews/index.vue')
      },
      {
        path: 'news-view', // 子路由 path 不需要写完整路径
        component: () => import('../views/CheckNews/views/newsView.vue')
      },
      {
        path: 'news-edit', // 子路由 path 不需要写完整路径
        component: () => import('../views/CheckNews/views/newsEdit.vue')
      },
      {
        path: 'recruitment', // 子路由 path 不需要写完整路径
        component: () => import('../views/Recruitment/index.vue')
      },
      
    ],
    redirect: '/home/publish-news'
  }
]

// 创建路由实例，使用 HTML5 History 模式
const router = createRouter({
  history: createWebHistory(),
  routes
})

// 解决重复导航报错问题（Vue Router 4 默认不报错，一般不需要处理）
// 如果你仍想捕获错误，可以这样写：

const originalPush = router.push
router.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router
